<script>
  import { onDestroy } from 'svelte';
  import { link } from 'svelte-routing';
  import { fade } from 'svelte/transition';
  import { listenToChannel } from './Api/api';
  import { broadcaster } from './Components/Chat/Broadcast/broadcast-store';

  export let channelId = '';

  let channel = null;

  $: channelId && listenToChannelData(channelId);

  let unsubscribeListenToChannel;

  onDestroy(() => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }
  });

  const listenToChannelData = async (id) => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }
    unsubscribeListenToChannel = await listenToChannel(id, (docRef) => {
      if (docRef.exists) {
        channel = { ...docRef.data(), id: docRef.id };
      }
    });
  };
</script>

<header in:fade>
  {#if !$broadcaster.isBroadcasting && !$broadcaster.isInitializingPublish}
    <a class="nav-btn" href="/reporter" use:link>
      <span class="material-icons"> arrow_back </span>
    </a>
  {/if}
  <h1>{channel ? channel.name : '...'}</h1>
</header>

<style src="./reporterHeader.scss"></style>
